<template>
  <div class="home view nav-spacing">
    <title-bar :with-logo="true"></title-bar>

    <div v-if="loading" class="text-center" style="margin-top: 2em;">
      <img src="@/img/hensel-loading.svg" alt="loading">
    </div>
    <template v-else>
      <form @submit="registerDevice">
        <div class="container spacer-bottom">
          <div class="row">
            <div class="col-xs-12">
              <input type="email" name="username" :placeholder="_('email address')"
                     class="xlarge-text"
                     autocorrect="off"
                     autocapitalize="off"
                     autocomplete="off"
                     spellcheck="false"
                     inputmode="email"
                     v-model="username">
            </div>
            <div class="col-xs-12">
              <input type="password" name="pin" :placeholder="_('password')"
                     class="xlarge-text"
                     autocorrect="off"
                     autocapitalize="off"
                     autocomplete="off"
                     spellcheck="false"
                     inputmode="numeric"
                     pattern="[0-9]*"
                     v-model="password">
            </div>

            <div class="col-xs-12">
              <input v-model="saveCredentials" id="save_pw" type="checkbox" name="save-password">
              <label for="save_pw" class="large-text">
                <span class="glyphicon glyphicon-check"></span>
                <span class="glyphicon glyphicon-unchecked"></span>
                {{ _('save credentials') }}
              </label>
            </div>
            <div class="col-xs-12">
              <button type="submit"
                      name="submit"
                      class="bg-light-blue xlarge-text"
              >
                {{ _('SIGN IN') }}
              </button>
            </div>
          </div>
        </div>
      </form>

      <div class="container">
        <div class="row">
          <div class="col-xs-12 spacer-top spacer-bottom">
            <bulma-accordion>
              <bulma-accordion-item>
                <h3 slot="title" v-html="_('Forgot password?')"></h3>
                <form slot="content" @submit="forgotPassword" class="row">
                  <div class="col-xs-12">
                    <div class="row">
                      <div class="border-wrap clearfix">
                        <div class="col-xs-10">
                          <input type="email" name="user" v-model="username"
                                 :placeholder="_('email address')"
                                 class="xlarge-text">
                        </div>
                        <div class="col-xs-2">
                          <button type="submit" name="submit" class="submit-button">
													<span class="glyphicon glyphicon-share-alt"
                                aria-hidden="true"></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <p>
                      <!-- @formatter:off -->
                      {{_('Geben Sie bitte Ihre E-Mail Adresse ein, mit der Ihr Konto eingerichtet wurde und wir schicken Ihnen Ihr Passwort zu.')}}
                      <!-- @formatter:on -->
                    </p>
                    <p>
                      <!-- @formatter:off -->
                      {{_('Oder wenden Sie sich an Ihren persönlichen Ansprechpartner')}}
                      <!-- @formatter:on -->
                    </p>
                  </div>
                </form>
              </bulma-accordion-item>
              <bulma-accordion-item v-if="!hideAccessForm">
                <h3 slot="title" v-html="_('Request access?')"></h3>
                <access-form slot="content"></access-form>
              </bulma-accordion-item>
            </bulma-accordion>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TitleBar from '../components/TitleBar'
import Modal from '../components/Modal'
import AccessForm from '../components/AccessForm'
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
import { v1 } from 'uuid'
import System from '@/_system.js'

export default {
  name: 'Login',
  mixins: [],
  components: { AccessForm, BulmaAccordion, BulmaAccordionItem, Modal, TitleBar },
  data () {
    return {
      username: '',
      password: '',
      saveCredentials: false,
      loading: false,
    }
  },
  computed: {
    ...mapState({
      'user': state => state.Api.Users.current,
      'apiVersion': state => state.apiVersion,
      'baseUrl': state => state.Api.apiBaseUrl,
      'language': state => state.Api.Localizations.language,
      'hideAccessForm': state => state.hideAccessForm,
    }),
  },
  async beforeMount () {
    try {
      let storedUserMail = await this.$localforage.getItem('userEmail')
      if (storedUserMail) {
        this.username = storedUserMail
      }
    } catch (e) {
      console.error(e)
    }

    try {
      this.saveCredentials = await this.$localforage.getItem('saveCredentials')
    } catch (e) {
      console.error(e)
    }

    await System.setStatusBarStyle('DEFAULT')
  },
  async beforeDestroy () {
    await System.setStatusBarStyle('LIGHT')
  },
  methods: {
    ...mapActions({
      register: 'Api/Devices/register',
      login: 'Api/Users/login',
      fetchAttributes: 'Api/Converters/attributes',
      sendForgotPassword: 'Api/Users/forgotPassword',
    }),
    async getUuid () {
      let uuid = await this.$localforage.getItem('deviceUUID')

      if (uuid) {
        return uuid
      }

      const systemUuid = (await System.getDeviceId()).uuid

      if (systemUuid) {
        await this.$localforage.setItem('deviceUUID', systemUuid)

        return systemUuid
      }

      uuid = v1()

      await this.$localforage.setItem('deviceUUID', uuid)

      return uuid
    },
    async registerDevice (e) {
      e.preventDefault()

      this.loading = true

      try {
        const uuid = await this.getUuid()

        window.initMatomo(uuid)

        //use the new api login
        const deviceName = await System.getDeviceName()
        const system = await System.getDevicePlatformOption()

        const registerResult = await this.register({
          identifier: uuid,
          username: this.username,
          password: this.password,
          terms_accepted: true,
          platform: (await System.getDeviceInfo()).operatingSystem,
          system,
          app_id: system !== 'web' ? 'App' : 'Website',
          name: deviceName,
        })

        this.$store.commit('Api/setAuthToken', registerResult.auth_token)
        const token = registerResult.auth_token

        sessionStorage.setItem(process.env.VUE_APP_AUTH_TOKEN_STORAGE_KEY, token)

        await this.login({ token })

        await this.$localforage.setItem('saveCredentials', this.saveCredentials)
        if (this.saveCredentials) {
          await this.$localforage.setItem('userEmail', this.username)
        } else {
          await this.$localforage.removeItem('userEmail')
        }

        await this.fetchAttributes()

        this.$router.push('/home', () => null, () => null)
      } catch (err) {
        this.apiErrorHandler(err)
      } finally {
        this.loading = false
      }
    },
    async forgotPassword (e) {
      e.preventDefault()
      try {
        await this.sendForgotPassword({
          email: this.username,
          identifier: await this.$localforage.getItem('deviceUUID'),
        })

        this.$store.commit('setLatestError', {
          code: '',
          message: this._('Thank You for your request.'),
          hidden: false,
        })
      } catch (err) {
        this.apiErrorHandler(err)
      }
    },
  },
}
</script>

<style>
.home.view.nav-spacing > * {
  max-width: 1000px;
  margin: 0 auto;
}
</style>
